import React, { useContext } from 'react';
import { RenderMode } from '@oneaudi/render-mode-service';
import { ThemeProvider } from '@oneaudi/unified-web-common';
import { Context } from '../../../context/Context';
import DesktopMenu from './desktop/DesktopMenu';
import MobileMenu from './mobile/MobileMenu';
import { darkTheme } from '../../../theme';

const Submenu: React.FC = () => {
  const { theme, hasLinks, hasCta, renderMode } = useContext(Context);
  const submenuTheme = process.env.IS_LEGACY ? theme : darkTheme; // on classic - both themes available, on Alpha - only darkTheme,

  return (
    <ThemeProvider theme={submenuTheme}>
      {renderMode === RenderMode.DEFAULT && (hasCta || hasLinks) && (
        <>
          {hasLinks && <DesktopMenu />}
          {(hasCta || hasLinks) && <MobileMenu />}
        </>
      )}

      {/* 
      EDIT MODE: always render Mobile and Desktop menu to enable editing in the Universal Editor.
    */}
      {renderMode === RenderMode.EDIT && (
        <>
          <DesktopMenu />
          <MobileMenu />
        </>
      )}
    </ThemeProvider>
  );
};

export default Submenu;
